/**
 * @Author: 左建
 * @Date: 2022/6/30 10:22
 * @LastEditTime: 2022/6/30 10:22
 * @Description: vue 插件注册
*/
// 全局组件导入
import globalCpns from "@/components/zj-global-cpns"

function install (Vue) {
    // 注册全局组件
    Object.keys(globalCpns).forEach(item => {
        Vue.component(item, globalCpns[item])
    })
}

export default install
